import React from 'react';
import PropTypes from 'prop-types';

import Suggestion from './Suggestion';

import styles from './index.scss';

const SuggestionsList = ({ phrase, searchValue }) => (
    <div className={styles.suggestions}>
        <ul className={styles.suggestions__list}>
            {phrase.map((suggestion, index) => (
                <Suggestion
                    key={`${index}-${suggestion.text}`}
                    suggestion={suggestion}
                    searchValue={searchValue}
                />
            ))}
        </ul>
    </div>
);

SuggestionsList.propTypes = {
    phrase: PropTypes.array.isRequired,
    searchValue: PropTypes.string.isRequired,
};

export default SuggestionsList;
